:host {
  --v-space: #{space()};
  --v-around-top: 0;
  --v-around-bottom: 0;
  --v-around: 0;

  display: flex;
  color: inherit;
  font-weight: inherit;
  font-family: inherit;
  letter-spacing: inherit;

  ::slotted(*) {
    // fix IE11 not wrapping text
    max-width: 100%;
    padding-top: calc(var(--v-space) * var(--v-around-top));
    padding-bottom: calc(var(--v-space) * var(--v-around-bottom));
    margin: 0;
  }

  ::slotted(*:not(:last-child)) {
    margin-bottom: calc(var(--v-space) * (1 - var(--v-around)));
  }

  ::slotted(stzh-show) {
    --show-display: block;
  }

  ::slotted(stzh-vspace),
  ::slotted(stzh-hspace),
  ::slotted(stzh-row),
  ::slotted(stzh-container),
  ::slotted(stzh-section) {
    align-self: stretch;
    flex-grow: 1;
  }
}

:host(:empty),
:host([around]:not([around="false"])) {
  --v-around-top: 1;
  --v-around-bottom: 1;
  --v-around: 1;
}

:host(:empty) {
  height: var(--v-space);
}

:host([around-top]:not([around-top="false"])) {
  --v-around-top: 1;
  --v-around: 1;
}

:host([around-bottom]:not([around-bottom="false"])) {
  --v-around-bottom: 1;
  --v-around: 1;
}

/* Border variants */

:host([border="top"]),
:host([border="top-bottom"]) {
  border-top: 1px solid $baseBorderColor;
}

:host([border="bottom"]),
:host([border="top-bottom"]) {
  border-bottom: 1px solid $baseBorderColor;
}

/* Space variants */

@each $spaceCurve, $value in $spaceCurves {
  $defaultSize: map-get($value, "size");
  $breakpointSizes: map-get($value, "sizes");

  // :host([curve="#{$spaceCurve}"]) > .stzh-vspace {
  :host([curve="#{$spaceCurve}"]) {
    --v-space: #{space($defaultSize)};

    @each $breakpoint, $size in $breakpointSizes {
      @include mq($from: $breakpoint) {
        --v-space: #{space($size)};
      }
    }
  }
}

@mixin spaceProps($breakpoint: null) {
  @each $space, $value in $spaceSizes {
    @if $breakpoint {
      // :host([size-#{$breakpoint}="#{$space}"]) > .stzh-vspace {
      :host([size-#{$breakpoint}="#{$space}"]) {
        @include mq($from: $breakpoint) {
          --v-space: #{$value};
        }
      }
    } @else {
      // :host([size="#{$space}"]) > .stzh-vspace {
      :host([size="#{$space}"]) {
        --v-space: #{$value};
      }
    }
  }
}

@include spaceProps();

@each $breakpoint, $size in $breakpoints {
  @include spaceProps($breakpoint);
}

.stzh-vspace {
  flex-grow: 1;
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0;
  margin: 0;

  &--border-top {
    border-top: 1px solid $baseBorderColor;
  }

  &--border-bottom {
    border-bottom: 1px solid $baseBorderColor;
  }

  /* Justify content variants */

  &--justify-center {
    justify-content: center;
  }

  &--justify-end {
    justify-content: flex-end;
  }

  &--justify-between {
    justify-content: space-between;
  }

  &--justify-around {
    justify-content: space-around;
  }

  &--justify-evenly {
    justify-content: space-evenly;
  }

  /* Align items variants */

  &--items-end {
    align-items: flex-end;
  }

  &--items-center {
    align-items: center;
  }

  &--items-baseline {
    align-items: baseline;
  }

  &--items-stretch {
    align-items: stretch;
  }
}
